export interface IPagination {
  mediaType: string;
  searchField: string;
  currentSite: string;
  paging: {
    maxItems: number;
    skipCount: number;
  };
}
